// Speaker notes arrive as Google Slides stores them, control characters and
// all. A soft line break (Shift+Enter) is a vertical tab, and Google uses a few
// other C0 controls as markers; iOS draws each one as a "NO GLYPH" box in the
// middle of the note (seen in COP-126's screenshot). Cleaned here, at display
// time, so it also fixes notes sent by extensions already in the Web Store.
// eslint-disable-next-line no-control-regex
const SOFT_BREAK = /\u000b/g;
// Every C0 control except tab, line feed and carriage return, plus DEL.
// eslint-disable-next-line no-control-regex
const OTHER_CONTROLS = /[\u0000-\u0008\u000c\u000e-\u001f\u007f]/g;

export const cleanNoteText = (raw: string): string =>
  raw.replace(SOFT_BREAK, "\n").replace(OTHER_CONTROLS, "");
